import React from 'react';
import { ModalPageView } from './modal-manager';
import { Button } from '@cotera/client/v0/components/ui/button';

export const ConfirmDestructiveActionModal: React.FC<{
  title: string;
  subtitle: string;
  confirmLabel: string;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void | Promise<void>;
}> = ({ title, subtitle, confirmLabel, onConfirm, onCancel }) => (
  <ModalPageView title={title} subtitle={subtitle} className="px-4 py-4">
    <div className="flex flex-col gap-4">
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={() => void onCancel()}>
          Cancel
        </Button>
        <Button variant="destructive" onClick={() => void onConfirm()}>
          {confirmLabel}
        </Button>
      </div>
    </div>
  </ModalPageView>
);
